export default __webpack_public_path__ + "static/media/Countryside_tours.cba78a70.webp";